import { Box, TextField, IconButton, CircularProgress } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

const PurchaseOrderSearch = ({ values, onChange, onSearch, loading = false }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 0.5,
        width: "100%",
      }}
    >
      <TextField
        size="small"
        placeholder={t("assing.purchaseOrder")}
        value={values.poNumber}
        onChange={(e) =>
          onChange((prev) => ({ ...prev, poNumber: e.target.value }))
        }
        onKeyDown={(e) => e.key === "Enter" && !loading && onSearch()}
        disabled={loading}
        sx={{
          width: 170,
          "& .MuiInputBase-root": {
            height: 36,
            fontSize: 14,
          },
        }}
      />

      <TextField
        size="small"
        placeholder={t("assing.poItem")}
        value={values.poItem}
        onChange={(e) =>
          onChange((prev) => ({ ...prev, poItem: e.target.value }))
        }
        onKeyDown={(e) => e.key === "Enter" && !loading && onSearch()}
        disabled={loading}
        sx={{
          width: 80,
          "& .MuiInputBase-root": {
            height: 36,
            fontSize: 14,
          },
        }}
      />

      <IconButton
        color="primary"
        size="small"
        onClick={onSearch}
        disabled={loading}
        sx={{ p: "4px" }}
      >
        {loading ? <CircularProgress size={18} /> : <SearchIcon sx={{ fontSize: 20 }} />}
      </IconButton>
    </Box>
  );
};

export default PurchaseOrderSearch;